import useCheckoutStore from "../store/checkout";
import { Box, Button, Stack, SvgIcon, Typography } from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import l10n from "../lib/l10n";
import { ReactComponent as IconMessage_ } from "../../images/message.svg";
import { getUrlReferrer } from "../lib/utils";
import Price from "./Price";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyIcon from '@mui/icons-material/Key';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { checkoutActions } from "../store/checkout";
import CheckoutButton from "./CheckoutButton";
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
const availableProcesses = Array.from(l10n.wppr_wallpaper_checkout_processes);
const isLoggedIn = l10n.hasOwnProperty('u_role');
const enabledForGuests = l10n.wppr_wallpaper_checkout_guest.toString() === 'yes';
const infoCase = l10n.wppr_wallpaper_askinfo_case.toString();
const buyNowLabel = 'Cassa';

if (!isLoggedIn && !enabledForGuests) {
  availableProcesses.splice(0, availableProcesses.length);
  availableProcesses.push("login");
}

switch(infoCase) {
  case "no":
  default:
    break;
  case "always":
    availableProcesses.splice(0, availableProcesses.length);
    availableProcesses.push('info');
    break;
  case "guest":
    if (!isLoggedIn && !enabledForGuests) {
      availableProcesses.splice(0, availableProcesses.length);
      availableProcesses.push('info');
      console.log('porchiddio');
    }
    break;
};

const checkoutButtons = {
  "buynow": {
    label: buyNowLabel,
    text: <Price />,
    variant: 'contained',
    color: 'success',
  },
  "addtocart": {
    startIcon: <AddShoppingCartIcon />,
    label: 'Aggiungi',
    text: 'al carrello',
    keepVisible: 'label',
  },
  "order": {
    startIcon: <AttachEmailIcon />,
    label: 'Preventivo',
    text: <Typography>via email</Typography>,
    keepVisible: 'label',
  },
  "order_simple": {
    startIcon: <ReceiptLongIcon />,
    label: 'Ordina',
    text: <Typography>il prodotto</Typography>,
    keepVisible: 'label',
  },
  "quote": {
    startIcon: <ReceiptLongIcon />,
    label: 'Richiedi',
    text: 'preventivo',
    keepVisible: 'text',
  },
  "info": {
    startIcon: <SvgIcon component={IconMessage_} inheritViewBox={true} />,
    label: 'Info',
    text: 'Contattaci per informazioni',
    keepVisible: 'label',
  },
  "login": {
    startIcon: <KeyIcon />,
    label: 'Accedi per fare un ordine',
    text: 'Clicca qui per accedere',
    keepVisible: 'label',
  },
};

function CheckoutButtons() {
  const { dispatch: dispatchCheckoutAction } = useCheckoutStore();

  const onClick = (process) => {
    switch(process) {
      case "none":
      default:
        // no action
        break;
      case "buynow":
        dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_BUY_NOW);
        break;
      case "addtocart":
        dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_ADD_TO_CART);
        break;
      case "order":
        dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_CREATE_ORDER);
        break;
      case "login":
        window.location.href = getUrlReferrer(l10n.url_myaccount, window.location.href);
        break;
      case "quote":
      case "info":
        dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_CREATE_QUOTE);
        break;
    }
  };

  return (
    <>
      {availableProcesses.map((process, key) => 
        <CheckoutButton key={key} onClick={() => onClick(process)} {...checkoutButtons[process]} />
      )}
      {(availableProcesses.includes("addtocart") && (isLoggedIn || enabledForGuests)) && (
        <BuyNowButton onClick={() => onClick('buynow')} {...checkoutButtons['buynow']} />
      )}
      {!availableProcesses.includes("addtocart") 
      && availableProcesses.every(element => ["order", "quote"].includes(element)) && (
        <Box>
          <Price>
            <Typography>Totale</Typography>
          </Price>
        </Box>
      )}
    </>
  );
};

function BuyNowButton({ label, text, variant, color, onClick }) {
  return (
    <Button
      variant={variant}
      color={color}
      onClick={onClick}
      sx={{
        lineHeight: 1.4,
        borderRadius: 0,
        height: '100%'
      }}
      endIcon={<ArrowForwardIosIcon style={{ fontSize: '1em', marginLeft: 36, marginRight: 4 }} />}
    >
      <Stack textAlign={'left'}>
        {label}
        {text}
      </Stack>
    </Button>
  );
}

export default CheckoutButtons;